import _ from 'lodash';
import { money, pluralize } from '@jgile/laravel-vue/resources/js/util';

const dateOptions = {
    local: true,
    format: {
        datetime: {
            written: {
                small: 'MMM Do, h:mm a', // Jan 4th, 10:33 am
                medium: 'MMM Do, YYYY, h:mm a', // Jan 4th, 1999, 10:33 am
                large: 'dddd, MMMM Do YYYY, h:mm a', // Thursday, January 4th 1965, 10:33 am
            },
            small: 'YY-M-D h:mm a', // 65-12-1 10:35 am
            medium: 'YYYY-M-D h:mm a', // 1965-12-1 10:35 am
            large: 'YYYY-MM-DD h:mm a', // 1965-12-01 10:35 am
        },
        date: {
            written: {
                small: 'MMM Do', // Jan 4th
                medium: 'MMM Do, YYYY', // Jan 4th, YYYY
                large: 'dddd, MMMM Do YYYY', // Thursday, January 4th 1965
            },
            small: 'YY-M-D', // 65-12-1
            medium: 'YYYY-M-D', // 1965-12-1
            large: 'YYYY-MM-DD', // 1965-12-01
        },
        time: {
            small: 'h:mm', // 10:35
            medium: 'h:mm a', // 10:35 am
            large: 'h:mm:ss a', // 10:35:06 am
        },
    },
};

const MyMixins = {
    install(Vue) {
        Vue.mixin({
            data() {
                return {
                    loadComponent: 1,
                    enableDebug: false,
                };
            },
            filters: {
                money: money,
                number(x) {
                    if (x === null) {
                        return '0';
                    }
                    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
                },

                /**
                 * Time
                 */
                time(value) {
                    if (!value) return '';
                    return formatDate(value, dateOptions.format.time.medium);
                },
                shortTime(value) {
                    if (!value) return '';
                    return formatDate(value, dateOptions.format.time.small);
                },
                longTime(value) {
                    if (!value) return '';
                    return formatDate(value, dateOptions.format.time.large);
                },

                /**
                 * Date
                 */
                date(value) {
                    if (!value) return '';
                    return formatDate(value, dateOptions.format.date.large);
                },
                shortDate(value) {
                    if (!value) return '';
                    return formatDate(value, dateOptions.format.date.medium);
                },
                writtenDate(value) {
                    if (!value) return '';
                    return formatDate(value, dateOptions.format.date.written.medium);
                },

                /**
                 * DateTime
                 */
                dateTime(value) {
                    if (!value) return '';
                    return formatDate(value, dateOptions.format.datetime.large);
                },
                shortDateTime(value) {
                    if (!value) return '';
                    return formatDate(value, dateOptions.format.datetime.medium);
                },
                writtenDateTime(value) {
                    if (!value) return '';
                    return formatDate(value, dateOptions.format.datetime.written.medium);
                },

                /**
                 * Conversions
                 */
                utcToLocal(date, format) {
                    return format ? moment.utc(date, format).local() : moment.utc(date).local();
                },
                localToUtc(date, format) {
                    return format ? moment(date, format).utc() : moment(date).local();
                },
            },
            computed: {
                vars() {
                    return window.vars;
                },
                Bus() {
                    return Bus;
                },
                $livewire() {
                    return window.Livewire;
                },
                _userType() {
                    return this._isAdmin ? 'admin' : this._isAdvertiser ? 'advertiser' : 'team';
                },
                _isAdmin() {
                    return _.get(Spark, 'state.currentTeam.team_type') === 2;
                },
                _isAdvertiser() {
                    return _.get(Spark, 'state.currentTeam.team_type') === 1;
                },
                _isTeam() {
                    return _.get(Spark, 'state.currentTeam.team_type') === 0 || _.get(Spark, 'state.currentTeam.team_type') === 3;
                },
                _window() {
                    return window;
                },
            },
            methods: {
                _size: require('lodash/size'),
                _isEqual: require('lodash/isEqual'),
                _default: require('lodash/defaultTo'),
                _chain: require('lodash/chain'),
                _includes: require('lodash/includes'),
                _get: require('lodash/get'),
                _has: require('lodash/has'),
                _set: require('lodash/set'),
                _pluralize: pluralize,
                __(key, replacements) {
                    return this.$t(key, replacements);
                },
                _dateTimeString(date, format = null, assumeUTC = true, toLocal = false) {
                    return window.dateTimeString(date, format, assumeUTC, toLocal);
                },
                _asset(asset) {
                    return _.trim(Spark.assetUrl, '/') + '/' + _.trim(asset, '/');
                },
                reloadComponent() {
                    this.loadComponent++;
                },
            },
        });

        Vue.prototype.$vueData = {
            process(response) {
                const data = this.getData(response);
                const message = this.getMessage(response);

                if (message) {
                    this.alert(message);
                }

                return data;
            },
            getMessage(response) {
                if (_.has(response, 'meta.message')) {
                    return _.get(response, 'meta.message');
                }

                if (_.has(response, 'data.meta.message')) {
                    return _.get(response, 'data.meta.message');
                }

                if (_.isString(response)) {
                    return response;
                }

                return null;
            },
            getData(response) {
                if (_.has(response, 'data')) {
                    return this.getData(_.get(response, 'data'));
                }

                return response;
            },
            getMeta(response) {
                if (_.has(response, 'meta')) {
                    return this.getMeta(_.get(response, 'meta'));
                } else if (_.has(response, 'data')) {
                    return this.getMeta(_.get(response, 'data'));
                }

                return response;
            },
        };
    },
};

export default MyMixins;
